<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">University Profile</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool01/14.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9 px-3 ">
                <div class="section-heading text-center text-md-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary text-center text-md-start">The Arni School of Technology</h2>
                <p align="justify">Welcome to The ARNI School of Technologies (AST), the place where ideas turn into reality. The
                    students seeking careers in a variety of technological sectors can learn postgraduate and
                    undergraduate courses in Arni University. AST is committed to shaping the careers of next-generation
                    engineers, technologists, and innovators. AST provides a perfect blend of practical exposure,
                    academic rigor, and advanced technologies to equip our students with the required skills and
                    knowledge in this ever-evolving world of technology.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9 px-3">
                <p align="justify"><b>Vision</b> – We have a long-term vision to craft a transformative learning environment where
                    students are
                    not just taught technical skills but are provided with relevant exposure that helps them to lead and
                    drive growth in the technological landscape.
                </p>
                <p align="justify"><b>Mission</b> – We are on a mission to spread knowledge and skills that empower students in this
                    dynamic
                    field of technology and innovations. We aim to provide them with a platform that encourages
                    interdisciplinary collaboration, hands-on learning, and research-driven exploration.
                </p>
                <h3>Postgraduate and Undergraduate Courses for Science Students</h3>
                <p align="justify">Arni School of Technology offers postgraduate and undergraduate science courses, designed in
                    collaboration with industry experts. The program provides practical experience through cutting-edge
                    laboratories and resources. The school fosters a supportive environment for intellectual growth and
                    personal development, encouraging extracurricular activities and fostering a supportive learning
                    environment for students to flourish as individuals.
                </p>
                <p align="justify"><b>Scope: </b> Students at Arni School of Technology have an unmatched educational experience that
                    combines
                    academic understanding with real-world application.
                </p>
                <ul>
                    <li>Using demanding coursework, practical labs, and research opportunities, we enable our graduates
                        to become proficient technologists capable of resolving intricate issues.
                    </li>
                    <li>Creative thinkers capable of propelling technological progress.</li>
                    <li>Professionals who are ready for the industry and eager to contribute significantly to their
                        fields of expertise.
                    </li>
                </ul>
                <p align="justify"><b>Join us at The Arni School of Technology, where the scope of your future is as expansive as your
                    ambitions.</b>
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 d-flex justify-content-center mt-1-9">
                <div class="counter-wrapper ">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">18</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 d-flex justify-content-center mt-1-9 ">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">32</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 d-flex justify-content-center mt-1-9">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">5</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 d-flex justify-content-center mt-1-9">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Civil Engineering</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">B.Tech(Civil)</td>
                        </tr>
                        <tr>
                            <td class="time">M.Tech(Civil)</td>
                        </tr>
                        <tr>
                            <td class="time">Ph.D Civil</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Civil Engineering</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">B.Tech(Civil)</td>
                        </tr>
                        <tr>
                            <td class="time">M.Tech(Civil)</td>
                        </tr>
                        <tr>
                            <td class="time">Ph.D Civil</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Computer Science Engineering</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">B.Tech(CS)</td>
                        </tr>
                        <tr>
                            <td class="time">M.Tech(CS)</td>
                        </tr>
                        <tr>
                            <td class="time">Ph.D CSE</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">ECE & EE</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">B.Tech(ECE)</td>
                        </tr>
                        <tr>
                            <td class="time">B.Tech(EE)</td>
                        </tr>
                        <tr>
                            <td class="time">Diploma (EE)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Computer Science & Applicaton</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BCA</td>
                        </tr>
                        <tr>
                            <td class="time">MCA</td>
                        </tr>
                        <tr>
                            <td class="time">Integrated Program-BCA & MCA</td>
                        </tr>
                        <tr>
                            <td class="time">Ph.D Computer Application</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Cyber Security & AI</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Diploma in Artifical Intelligence and Machine Learning</td>
                        </tr>
                        <tr>
                            <td class="time">Diploma in Forensic Science & Cyber Security</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
